var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoStatic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 799.89 291.91",
    enableBackground: "new 0 0 799.89 291.91",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 17.43,15.26 17.43,87.26 146.3,87.26 146.3,156.51  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#08CDFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 146.3,
    y1: 15.26,
    x2: 146.3,
    y2: 46.82
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#08CDFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 17.43,
    y1: 156.51,
    x2: 17.43,
    y2: 124.17
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 229.22,156.51 229.22,15.86 359.02,15.86 359.02,156.51  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#08CDFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 231.22,
    y1: 87.79,
    x2: 301.01,
    y2: 87.79
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 571.42,19.3 442.55,19.3 442.55,156.77 571.42,156.77  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 655.89,
    y1: 87.04,
    x2: 655.89,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 782.84,17.01 782.84,87.18 656.61,87.18 782.84,157.8  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#08CDFF",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 655.89,
    y1: 157.8,
    x2: 655.89,
    y2: 125.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 17.68,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 17.68,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01CFFF",
    cx: 17.68,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01CFFF",
    cx: 145.7,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 145.7,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 145.7,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 229.28,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01CFFF",
    cx: 229.28,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 229.28,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 358.35,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 358.35,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 358.35,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 442.55,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 442.55,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 442.55,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 570.34,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01CFFF",
    cx: 570.34,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 570.34,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 655.72,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 655.72,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01CFFF",
    cx: 655.72,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 782.21,
    cy: 17.68,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 782.21,
    cy: 86.73,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 782.21,
    cy: 155.78,
    r: 17.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.85,291.91v-66.87h8.41v66.87H43.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.27,291.91v-66.87h8.41v66.87H122.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M200.7,291.91v-66.87h8.41v66.87H200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M270.34,232.68v-7.64h106.99v7.64h-49.29v59.23h-8.41v-59.23H270.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01CFFF",
    d: "M418.03,268.98v-7.64h39.36v7.64H418.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M528.5,291.91v-66.87h59.97c6.04,0,10.48,1.56,13.35,4.68c2.86,3.12,4.29,7.26,4.29,12.42 c0,3.63-0.72,6.8-2.17,9.5c-1.45,2.71-3.61,4.67-6.5,5.87c4.23,0.89,7.38,2.85,9.44,5.88c2.06,3.03,3.09,6.7,3.09,11.03 c0,5.22-1.44,9.44-4.33,12.66c-2.89,3.22-7.4,4.82-13.54,4.82H528.5z M599.07,243.86c0-3.38-0.97-6.08-2.9-8.12 s-5.07-3.06-9.4-3.06h-51.46v22.26h51.92C595.12,254.94,599.07,251.25,599.07,243.86z M590.4,262.01h-55.09v22.26h55.09 c8.2,0,12.3-3.73,12.3-11.18C602.7,265.7,598.6,262.01,590.4,262.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M747.32,291.91v-29.61h-68.17v29.61h-6.81v-66.87h6.81v29.61h68.17v-29.61h6.81v66.87H747.32z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStatic);
export default __webpack_public_path__ + "static/media/logoStatic.f2e7aea3dffcdb7fed6232f692a4444c.svg";
export { ForwardRef as ReactComponent };